/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useToggleTabContext } from 'bundles/cds-labs/components/ToggleTab/hooks/useToggleTabContext';
import type { ToggleTabValue } from 'bundles/cds-labs/components/ToggleTab/types';

export type ToggleTabPanelProps = {
  children: React.ReactNode;
  value: ToggleTabValue;
  className?: string;
};

const styles = {
  tabPanel: css`
    width: 100%;
  `,
};
const ToggleTabPanel = ({ children, value, className }: ToggleTabPanelProps) => {
  const { value: selectedValue, id } = useToggleTabContext();

  const { tabId, panelId } = React.useMemo(
    () => ({
      tabId: `${id}-tab-${value}`,
      panelId: `${id}-panel-${value}`,
    }),
    [id, value]
  );

  return (
    <div
      css={styles.tabPanel}
      className={className}
      style={{
        display: selectedValue === value ? 'block' : 'none',
      }}
      role="tabpanel"
      id={panelId}
      aria-labelledby={tabId}
      tabIndex={-1}
    >
      {children}
    </div>
  );
};

export default ToggleTabPanel;
